import { ReservationAdapter as CoreReservationAdapter } from '@core/adapters';

export class ReservationAdapter extends CoreReservationAdapter {}
